'use strict';

require("core-js/modules/es6.function.bind");

require("core-js/modules/es7.object.values");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buble = require('buble');

var _mdx = require('@mdx-js/mdx');

var _mdx2 = _interopRequireDefault(_mdx);

var _tag = require('@mdx-js/tag');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

exports["default"] = function (_ref) {
  var _ref$scope = _ref.scope,
      scope = _ref$scope === undefined ? {} : _ref$scope,
      _ref$components = _ref.components,
      components = _ref$components === undefined ? {} : _ref$components,
      _ref$mdPlugins = _ref.mdPlugins,
      mdPlugins = _ref$mdPlugins === undefined ? [] : _ref$mdPlugins,
      _ref$hastPlugins = _ref.hastPlugins,
      hastPlugins = _ref$hastPlugins === undefined ? [] : _ref$hastPlugins,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['scope', 'components', 'mdPlugins', 'hastPlugins', 'children']);

  var fullScope = _extends({
    MDXTag: _tag.MDXTag,
    components: components,
    props: props
  }, scope);

  var jsx = _mdx2["default"].sync(children, {
    mdPlugins: mdPlugins,
    hastPlugins: hastPlugins,
    skipExport: true
  }).trim();

  var _transform = (0, _buble.transform)(jsx),
      code = _transform.code;

  var keys = Object.keys(fullScope);
  var values = Object.values(fullScope); // eslint-disable-next-line no-new-func

  var fn = new (Function.prototype.bind.apply(Function, [null].concat(['_fn', 'React'], _toConsumableArray(keys), [code + '\n\n  return React.createElement(MDXContent, { components, ...props });'])))();
  return fn.apply(undefined, [{}, _react2["default"]].concat(_toConsumableArray(values)));
};